var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Cascader',{staticStyle:{"width":"100%"},attrs:{"filterable":"","options":_vm.list,"transfer":true,"disabled":_vm.disabled,"clearable":"","size":_vm.size},on:{"change":_vm.cascaderOnChange},model:{value:(_vm.cascaderSelected),callback:function ($$v) {_vm.cascaderSelected=$$v},expression:"cascaderSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }